exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-category[data-v-c9f18f6e] {\n  font-weight: bold;\n  font-size: 1.45em;\n}\n.toggle-link[data-v-c9f18f6e] {\n  cursor: pointer;\n  padding: 0 12px;\n}\n.toggle-window[data-v-c9f18f6e] {\n  border: 2px solid #f1f1f1;\n  padding: 8px;\n  margin-bottom: 4px;\n}\n#list-link[data-v-c9f18f6e] {\n  border-left: 2px solid #f1f1f1;\n}\n.toggle-bar[data-v-c9f18f6e] {\n  padding-bottom: 8px;\n  border-bottom: 2px solid #f1f1f1;\n}\np.no-vertical-margin[data-v-c9f18f6e] {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.project[data-v-c9f18f6e] {\n  margin-bottom: 1rem;\n}\n.list-pane[data-v-c9f18f6e] {\n  overflow-y: scroll;\n}\n@media (max-width: 650px) {\n.list-pane[data-v-c9f18f6e] {\n    max-height: 80%;\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c9f18f6e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/apartments/Apartments.vue
// module id = xM1Q
// module chunks = 1